// src/pages/TermsPage.tsx
import React from 'react';

const TermsPage = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8">Terms of Service</h1>
      
      <div className="prose lg:prose-lg">
        <p>
          Last updated: March 18, 2025
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
        <p className="mb-4">
          By accessing or using our service, you agree to be bound by these Terms. If you disagree with
          any part of the terms, you may not access the service.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">2. Description of Service</h2>
        <p className="mb-4">
          LoadDrive provides a platform for business document management, verification, and processing.
          Our services include document storage, identity verification, and business registration assistance.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">3. User Accounts</h2>
        <p className="mb-4">
          When you create an account with us, you must provide information that is accurate, complete, and
          current at all times. Failure to do so constitutes a breach of the Terms, which may result in
          immediate termination of your account on our service.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">4. User Responsibilities</h2>
        <p className="mb-4">
          You are responsible for safeguarding the password that you use to access the service and for any activities
          or actions under your password. You agree not to disclose your password to any third party.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">5. Content Ownership</h2>
        <p className="mb-4">
          You retain all rights to your data and documents uploaded to our service. By uploading content to our
          platform, you grant us a license to store, process, and display that content as necessary to provide our service.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">6. Acceptable Use</h2>
        <p className="mb-4">
          You agree not to use our service for any unlawful purposes or to upload any harmful, inappropriate, or illegal content.
          We reserve the right to remove any content that violates these terms.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">7. Termination</h2>
        <p className="mb-4">
          We may terminate or suspend access to our service immediately, without prior notice or liability, for any
          reason whatsoever, including without limitation if you breach the Terms.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">8. Limitation of Liability</h2>
        <p className="mb-4">
          In no event shall LoadDrive, nor its directors, employees, partners, agents, suppliers, or affiliates, be
          liable for any indirect, incidental, special, consequential or punitive damages, including without limitation,
          loss of profits, data, use, goodwill, or other intangible losses.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">9. Changes to Terms</h2>
        <p className="mb-4">
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
          material we will try to provide at least 30 days' notice prior to any new terms taking effect.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-4">10. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about these Terms, please contact us at terms@LoadDrive.com.
        </p>
      </div>
    </div>
  );
};

export default TermsPage;
